import { Injectable, InjectionToken, inject } from '@angular/core';
import { MessageId, TargetMessage } from '@angular/localize';
import { LocaleId } from '@trimble-gcs/i18n-types';

export const TRANSLATIONS_PATH = new InjectionToken<string>('TRANSLATIONS_PATH');

@Injectable({
  providedIn: 'root',
})
export class TranslationLoader {
  private translationsPath = inject(TRANSLATIONS_PATH);

  async fetchTranslations(
    localeId: LocaleId,
  ): Promise<Record<MessageId, TargetMessage> | undefined> {
    const response = await fetch(`${this.translationsPath}/${localeId}.json`);
    const json = await response.json();
    return json.translations;
  }
}
